/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * @summary 리뷰 목록 조회
 */
export const reviewsControllerGetReviewsQueryPageDefault = 1;

export const reviewsControllerGetReviewsQueryLimitDefault = 20;
export const reviewsControllerGetReviewsQueryLimitMax = 100;

export const reviewsControllerGetReviewsQuerySortByDefault = "created_at";
export const reviewsControllerGetReviewsQuerySortOrderDefault = "desc";
export const reviewsControllerGetReviewsQueryMinRatingMax = 5;

export const reviewsControllerGetReviewsQueryMaxRatingMax = 5;

export const reviewsControllerGetReviewsQueryIncludeDeletedDefault = false;

export const reviewsControllerGetReviewsQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(reviewsControllerGetReviewsQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(reviewsControllerGetReviewsQueryLimitMax)
      .default(reviewsControllerGetReviewsQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod
      .enum(["created_at", "calculated_rating"])
      .default(reviewsControllerGetReviewsQuerySortByDefault)
      .describe("정렬 기준"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(reviewsControllerGetReviewsQuerySortOrderDefault)
      .describe("정렬 순서"),
    search: zod.coerce.string().optional().describe("검색어"),
    reviewerId: zod.coerce
      .string()
      .optional()
      .describe("리뷰 작성자 ID로 필터링"),
    revieweeId: zod.coerce
      .string()
      .optional()
      .describe("리뷰 대상 ID (공급업체)로 필터링"),
    contractId: zod.coerce.string().optional().describe("계약 ID로 필터링"),
    minRating: zod.coerce
      .number()
      .min(1)
      .max(reviewsControllerGetReviewsQueryMinRatingMax)
      .optional()
      .describe("최소 평점 (1-5)"),
    maxRating: zod.coerce
      .number()
      .min(1)
      .max(reviewsControllerGetReviewsQueryMaxRatingMax)
      .optional()
      .describe("최대 평점 (1-5)"),
    includeDeleted: zod.coerce
      .boolean()
      .default(reviewsControllerGetReviewsQueryIncludeDeletedDefault)
      .describe("삭제된 리뷰 포함 여부"),
  })
  .strict();

export const reviewsControllerGetReviewsResponseTwoDataItemsItemCalculatedRatingMax = 5;

export const reviewsControllerGetReviewsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("리뷰 ID"),
              contractId: zod.string().describe("계약 ID"),
              reviewerId: zod.string().describe("리뷰 작성자 ID (구매자)"),
              revieweeId: zod.string().describe("리뷰 대상 ID (공급업체)"),
              positiveAspects: zod.array(zod.string()).describe("좋은 점 태그"),
              negativeAspects: zod
                .array(zod.string())
                .describe("아쉬운 점 태그"),
              detailedReview: zod.string().describe("상세 후기"),
              calculatedRating: zod
                .number()
                .min(1)
                .max(
                  reviewsControllerGetReviewsResponseTwoDataItemsItemCalculatedRatingMax,
                )
                .describe("계산된 평점 (1-5)"),
              createdAt: zod.string().describe("작성 일시"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 리뷰 상세 조회
 */
export const reviewsControllerGetReviewParams = zod
  .object({
    id: zod.coerce.string().describe("리뷰 ID"),
  })
  .strict();

export const reviewsControllerGetReviewResponseTwoDataCalculatedRatingMax = 5;

export const reviewsControllerGetReviewResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("리뷰 ID"),
        contractId: zod.string().describe("계약 ID"),
        reviewerId: zod.string().describe("리뷰 작성자 ID (구매자)"),
        revieweeId: zod.string().describe("리뷰 대상 ID (공급업체)"),
        positiveAspects: zod.array(zod.string()).describe("좋은 점 태그"),
        negativeAspects: zod.array(zod.string()).describe("아쉬운 점 태그"),
        detailedReview: zod.string().describe("상세 후기"),
        calculatedRating: zod
          .number()
          .min(1)
          .max(reviewsControllerGetReviewResponseTwoDataCalculatedRatingMax)
          .describe("계산된 평점 (1-5)"),
        createdAt: zod.string().describe("작성 일시"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 리뷰 삭제 (숨김 처리)
 */
export const reviewsControllerDeleteReviewParams = zod
  .object({
    id: zod.coerce.string().describe("리뷰 ID"),
  })
  .strict();

export const reviewsControllerDeleteReviewResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod.object({}).optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 공급업체 리뷰 통계 조회
 */
export const reviewsControllerGetSupplierStatsParams = zod
  .object({
    supplierId: zod.coerce.string().describe("공급업체 ID"),
  })
  .strict();

export const reviewsControllerGetSupplierStatsResponseTwoDataTotalReviewsMin = 0;

export const reviewsControllerGetSupplierStatsResponseTwoDataAverageRatingMin = 0;
export const reviewsControllerGetSupplierStatsResponseTwoDataAverageRatingMax = 5;

export const reviewsControllerGetSupplierStatsResponseTwoDataPositiveReviewCountMin = 0;

export const reviewsControllerGetSupplierStatsResponseTwoDataNegativeReviewCountMin = 0;

export const reviewsControllerGetSupplierStatsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        supplierId: zod.string().describe("공급업체 ID"),
        totalReviews: zod
          .number()
          .min(reviewsControllerGetSupplierStatsResponseTwoDataTotalReviewsMin)
          .describe("총 리뷰 수"),
        averageRating: zod
          .number()
          .min(reviewsControllerGetSupplierStatsResponseTwoDataAverageRatingMin)
          .max(reviewsControllerGetSupplierStatsResponseTwoDataAverageRatingMax)
          .describe("평균 평점 (1-5, 소수점 2자리)"),
        positiveReviewCount: zod
          .number()
          .min(
            reviewsControllerGetSupplierStatsResponseTwoDataPositiveReviewCountMin,
          )
          .describe("긍정 리뷰 수 (평점 4-5)"),
        negativeReviewCount: zod
          .number()
          .min(
            reviewsControllerGetSupplierStatsResponseTwoDataNegativeReviewCountMin,
          )
          .describe("부정 리뷰 수 (평점 1-2)"),
        latestReviewDate: zod
          .string()
          .nullable()
          .describe("최근 리뷰 작성 일시"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();
